import Vue from 'vue'
import Toasted from 'vue-toasted';

Vue.use(Toasted)

let failedOptions = {
    className: 'mToasted',
    type : 'error',
    icon : 'sad-tear',
    duration: 4000,
    iconPack:'fontawesome'
};

Vue.toasted.register('failedRequest',
    (payload) => {
        // if there is no message passed show default message
        if(!payload.message) {
            return "Oeps.. Er ging iets mis.."
        }
        // if there is a message show it with the message
        return "Oeps.. " + payload.message;
    },
    failedOptions
);

let successOptions = {
    className: 'mToasted',
    type: 'success',
    duration: 3000,
    icon: 'smile',
    iconPack: 'fontawesome'
};

Vue.toasted.register('successRequest',
    (payload) => {

        // if there is no message passed show default message
        if(! payload.message) {
            return "Succesvol geupdatet"
        }

        // if there is a message show it with the message
        return payload.message;
    },
    successOptions
);

let infoOptions = {
    className: 'mToasted',
    type: 'info',
    duration: 3000,
    icon: {name:'lightbulb-on'},
    position: 'top-left',
    iconPack: 'fontawesome',
    singleton: true
};

Vue.toasted.register('info',
    (payload) => {
        // if there is no message passed show default message
        if(! payload.message) {
            return " "
        }
        // if there is a message show it with the message
        return " " + payload.message;
    },
    infoOptions
);let serviceWorkerOptions = {
    className: 'mToasted',
    type: 'info',
    duration: 50000000,
    position: 'bottom-right',
    iconPack: 'fontawesome',
    singleton: true,
    action: [
        {
            text: 'Reload the page',
            onClick: (e, toastObject) => {
                window.location.reload(true)
            }
        }]
}
Vue.toasted.register('cacheUpdated',
    (payload) => {
        // if there is no message passed show default message
        if (!payload.message) {
            return " "
        }

        // if there is a message show it with the message
        return " " + payload.message;
    },
    serviceWorkerOptions
)